/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

// tslint:disable:variable-name

import { date, DateFormat, entity } from '@gh/core-data';
import { InvoicesDto } from './invoices.dto';

export const InvoicesMapper = entity<InvoicesDto>({
  updatedDate: date(DateFormat.DateTime),
});
